var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19631)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5752 17.5805L21.8779 32.1778C21.8774 32.1783 21.8769 32.1788 21.8765 32.1792C21.4403 32.6147 20.8682 32.875 20.2501 32.875C19.6312 32.875 19.0586 32.6141 18.6222 32.1778C18.6124 32.168 18.6027 32.1579 18.5933 32.1477L10.9933 23.9477L12.6068 22.4523L20.1881 30.6321C20.2166 30.6585 20.2367 30.6689 20.2449 30.6725C20.2471 30.6734 20.2488 30.6741 20.2501 30.6745C20.2513 30.6741 20.253 30.6734 20.2552 30.6725C20.2643 30.6685 20.2884 30.656 20.3222 30.6222L20.3249 30.6195L35.0249 16.0195L36.5752 17.5805Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.6,
    height: 16.9,
    fill: "white",
    transform: "translate(11 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckLight);
export default __webpack_public_path__ + "static/media/icon_check_light.cf504729.svg";
export { ForwardRef as ReactComponent };